import { makeStyles } from '@material-ui/core/styles';
import { pxToRem } from '../../../../styles/themes/vad/constants';
import { EVENT_TYPE } from '../../../../constants/index';
import { borderRadius } from '../../../../styles/themes/vad/borderRadius';

const useStyles = makeStyles(theme => ({
  root: {
    ...theme.shape.componentSpacing,
    [theme.breakpoints.up('lg')]: {
      marginBottom: theme.spacing(6), //this is to compensate the spacing created by Highlights section
    },
    '& h4': {
      marginBottom: theme.spacing(3),
      [theme.breakpoints.up('lg')]: {
        ...theme.mixins.marginLeft(pxToRem(-16)),
      },
    },
    '& svg': {
      width: theme.spacing(4),
      height: theme.spacing(4),
      ...theme.mixins.paddingRight(0),
    },

    '&.updated-font': {
      marginBottom: 80,
      [theme.breakpoints.down('md')]: {
        marginBottom: 40,
      },
      '& .richText': {
        marginBottom: 0,
        '& p': {
          fontSize: pxToRem(22),
          lineHeight: pxToRem(32),
          fontFamily: theme.custom.fontFamily.primaryRegular,

          [theme.breakpoints.down('md')]: {
            fontSize: pxToRem(20),
          },

          '&:last-child': {
            marginBottom: 0,
          },
        },

        '& a': {
          fontSize: pxToRem(22),
          lineHeight: pxToRem(32),
          fontFamily: theme.custom.fontFamily.primaryRegular,
          color: '#009086',
          [theme.breakpoints.down('md')]: {
            fontSize: pxToRem(20),
          },
        },
      },
    },
  },
  richTextOverride: {
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(2),
    '&.richText p': {
      ...theme.typography.body1,
      marginTop: '0',
      marginBottom: theme.spacing(2),
    },
    '&.richText ul': {
      paddingLeft: pxToRem(20)
    },
    '&.richText ol': {
      paddingLeft: pxToRem(20)
    },
    '&.richText li': {
      ...theme.typography.body1,
      marginTop: '0',
      marginBottom: theme.spacing(2),
    },
  },
  highLightHeading: {
    marginTop: theme.spacing(4),
    [theme.breakpoints.up('lg')]: {
      marginTop: theme.spacing(6),
    },

    '& .heading-text': {
      marginTop: theme.spacing(5),
      marginLeft: 0,
      marginRight: 0,
    },
  },
  categoryTags: {
    display: 'flex',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',

    // This comments for Event page
    '& span': {
      color: ({ contentType }) =>
        contentType === EVENT_TYPE && theme.mixins.SeaGreen(),
      borderRadius: ({ contentType }) =>
        contentType === EVENT_TYPE && borderRadius.b0,

    },
    '& .MuiChip-root': {
      ...theme.mixins.marginRight(pxToRem(10)),
      [theme.breakpoints.up('lg')]: {
        ...theme.mixins.marginRight(pxToRem(20)),
      },
    },
  },
  iconWrapper: {
    marginTop: theme.spacing(5),
    ...theme.mixins.paddingRight(theme.spacing(3)),
    '& .MuiAvatar-root': {
      marginRight: theme.spacing(2),
    },

    [theme.breakpoints.down('md')]: {
      transform: 'none',
      marginTop: theme.spacing(2),
    },
  },
  iconText: {
    display: 'flex',
    flexDirection: 'column',
  },
  tagContainer: {
    overflow: 'hidden',
    maxHeight: theme.spacing(10),
    transition: 'max-height 0.4s ease-in-out',
    [theme.breakpoints.up('lg')]: {
      maxHeight: '40px',
    },
    '&.showContent': {
      maxHeight: theme.spacing(50),
    },
  },
  toggleIcon: {
    ...theme.typography.body2Bold,
    position: 'relative',
    color: theme.mixins.AbuDhabiOrange(),
    cursor: 'pointer',
    display: 'inline-block',
    marginTop: pxToRem(28),

    [theme.breakpoints.up('lg')]: {
      marginTop: pxToRem(34),
    },

    '&:after': {
      content: "''",
      position: 'absolute',
      border: `solid ${theme.mixins.AbuDhabiOrange()}`,
      width: pxToRem(10),
      height: pxToRem(10),
      borderWidth: '0 2px 2px 0',
      transform: 'rotate(45deg)',
      top: `calc(50% - ${pxToRem(7)})`,
      ...theme.mixins.right(pxToRem(-24)),
    },
    '&.less': {
      '&:after': {
        top: `calc(50% - ${pxToRem(1.5)})`,
        transform: 'rotate(227deg)',
      },
    },
  },
}));

export default useStyles;
